import React from 'react';
import sIcon1 from '../../images/icons/icon_clock.svg'
import sIcon2 from '../../images/icons/icon_dart_board_2.svg'
import sIcon3 from '../../images/icons/icon_target.svg'

const Policy = [
    {
        title: 'Onze geschiedenis',
        subTitle: 'Praeventor begon als een ambitieus project van twee cybersecurity- en cloud-studenten aan de Hogeschool Utrecht. Wat begon als een idee tijdens colleges groeide al snel uit tot een gezamenlijke missie: bedrijven veiliger maken in een digitale wereld vol nieuwe dreigingen. Gewapend met de kennis en vaardigheden die ze tijdens hun studie ontwikkelden, begonnen ze met het bieden van beveiligingsoplossingen en adviezen aan kleine en middelgrote ondernemingen.\n' +
            '\n' +
            'Sinds de oprichting heeft Praeventor zich ontwikkeld tot een betrouwbare partner op het gebied van digitale veiligheid.',
        icon: sIcon1,
    },
    {
        title: 'Onze Missie',
        subTitle: 'Bij Praeventor streven we ernaar om bedrijven van elke omvang digitaal weerbaar te maken door preventieve en toegankelijke cybersecurity-oplossingen te bieden. Met een focus op innovatie en educatie helpen we organisaties niet alleen om risico’s te verminderen, maar ook om een sterke veiligheidscultuur op te bouwen. Wij geloven dat effectieve digitale beveiliging begint bij bewustwording en proactief handelen, en wij zetten ons in om deze visie te realiseren door middel van maatwerk, betrokkenheid en voortdurende ondersteuning.',
        icon: sIcon2,
    },
    {
        title: 'Onze Visie',
        subTitle: 'Praeventor ziet een toekomst waarin digitale veiligheid voor elke organisatie toegankelijk en vanzelfsprekend is. Wij geloven dat in een steeds complexere digitale wereld, bedrijven niet alleen beschermd moeten worden tegen dreigingen, maar ook empowered om zelfbewust en proactief met cybersecurity om te gaan. Met een combinatie van praktische technologie en continue educatie willen we de kloof dichten tussen technologische innovatie en veiligheidsbewustzijn, zodat beveiliging geen obstakel, maar een troef wordt voor groei en succes.\n' +
            '\n',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section bg-light" style={{ paddingBottom: "200px", paddingTop: "200px"}}>
            <div className="container">
                <div className="heading_block">
                    <h4 className="text-center">
                        Waar ligt onze passie?
                    </h4>
                    <h1 className="text-center">
                        Onze Afspraak aan onze klanten
                    </h1>
                </div>
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block">
                                <div className="iconbox_icon">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;